import React from 'react';
import PropTypes from 'prop-types';
import splitData from './splitData';
import Table from './Table';

const DashboardTable = ({ maxColumns, data }) => {
  const split = splitData(data, maxColumns);
  return (
    <div className="layout layout--flush u-mb-">
      {split.map((items, index) => <Table data={items} key={index} columns={maxColumns} />)}
    </div>
  );
};

DashboardTable.propTypes = {
  maxColumns: PropTypes.number,
  data: PropTypes.array.isRequired,
};
DashboardTable.defaultProps = {
  maxColumns: 2,
};

export default DashboardTable;
